export const S3_URL =
  "https://vl-public-documents.s3.ap-southeast-1.amazonaws.com/";

export const DOUGHNUT_COLORS = [
  "#0492FF",
  "#A1CDE8",
  "#F98AFF",
  "#9747FF",
  "#FFAE2C",
  "#FFDFAC",
  "#9B9A9A",
  "#D9D9D9",
  "#BCEFDB",
  "#218863",
];
